import { render } from "./VendorsView.vue?vue&type=template&id=5f8efeb8"
import script from "./VendorsView.vue?vue&type=script&lang=js"
export * from "./VendorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__